/** InsCoder WANG.J 2026-10-21 B + PRO sticky Apply lifecycle and responsive visibility **/
if (!customElements.get('cust-pro-hero')) {
 customElements.define('cust-pro-hero', class extends HTMLElement {
  connectedCallback() {
   this.onReady = () => this.initializeSticky();
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once:true });
   else this.initializeSticky();
  }
  initializeSticky() {
   if (!this.isConnected || this.updateSticky) return;
   this.bar = this.querySelector('.cust-pro-hero__sticky');
   if (!this.bar) return;
   this.mobile = window.matchMedia('(max-width: 768px)');
   this.updateSticky = () => { this.bar.hidden = !this.mobile.matches || this.getBoundingClientRect().bottom > 0; };
   this.mobile.addEventListener('change', this.updateSticky);
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(this.updateSticky);
    this.observer.observe(this);
   } else {
    this.onScroll = () => {
     if (this.scrollFrame) return;
     this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateSticky?.(); });
    };
    window.addEventListener('scroll', this.onScroll, { passive:true });
    window.addEventListener('resize', this.onScroll);
   }
   this.updateSticky();
  }
  disconnectedCallback() {
   document.removeEventListener('DOMContentLoaded', this.onReady);
   this.observer?.disconnect();
   this.mobile?.removeEventListener('change', this.updateSticky);
   if (this.onScroll) {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
   }
   if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
   if (this.bar) this.bar.hidden = true;
   this.observer = null;
   this.updateSticky = null;
   this.onScroll = null;
   this.scrollFrame = null;
  }
 });
}
/** InsCoder WANG.J 2026-10-21 E + PRO sticky Apply lifecycle and responsive visibility **/
